import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { getNumberComma } from '../../utils/numberUtils';

const ChanceTotalSummary = ({ totals }) => {
  return (
    <Stack
      direction="row"
      alignItems="stretch"
      justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
      spacing={{ xs: 1, md: 2 }}
      useFlexGap
      flexWrap="wrap"
      sx={{ my: { xs: 1.25, md: 2 }, px: 0 }}
      divider={<Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', md: 'block' } }} />}
    >
      <Stack direction="row" spacing={1} sx={{ minWidth: { xs: 'calc(50% - 4px)', sm: 'auto' } }}>
        <Typography variant="body2">총매출액:</Typography>
        <Typography variant="subtitle2">
          {getNumberComma(totals?.totalSales)}
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1} sx={{ minWidth: { xs: 'calc(50% - 4px)', sm: 'auto' } }}>
        <Typography variant="body2">총매입액:</Typography>
        <Typography variant="subtitle2">
          {getNumberComma(totals?.totalPurchase)}
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1} sx={{ minWidth: { xs: 'calc(50% - 4px)', sm: 'auto' } }}>
        <Typography variant="body2">매출이익:</Typography>
        <Typography variant="subtitle2">
          {getNumberComma(totals?.totalProfit)}
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1} sx={{ minWidth: { xs: 'calc(50% - 4px)', sm: 'auto' } }}>
        <Typography variant="body2">이익률:</Typography>
        <Typography variant="subtitle2">
          {getNumberComma(totals?.totalMargin)} %
        </Typography>
      </Stack>
    </Stack>
  );
};

export default ChanceTotalSummary;
